module.exports = __webpack_public_path__ + "static/media/distance.1bf12d7e.svg";